import createIcon from '../../createIcon';

/**
 * @component @name ChromeReaderMode
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgMTEuNUgyMFYxM0gxM1YxMS41Wk0xMyA5SDIwVjEwLjVIMTNWOVpNMTMgMTRIMjBWMTUuNUgxM1YxNFpNMjEgMy41SDNDMS45IDMuNSAxIDQuNCAxIDUuNVYxOC41QzEgMTkuNiAxLjkgMjAuNSAzIDIwLjVIMjFDMjIuMSAyMC41IDIzIDE5LjYgMjMgMTguNVY1LjVDMjMgNC40IDIyLjEgMy41IDIxIDMuNVpNMjEgMTguNUgxMlY1LjVIMjFWMTguNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ChromeReaderMode = createIcon('ChromeReaderMode', [
  [
    'path',
    {
      d: 'M13 11.5H20V13H13V11.5ZM13 9H20V10.5H13V9ZM13 14H20V15.5H13V14ZM21 3.5H3C1.9 3.5 1 4.4 1 5.5V18.5C1 19.6 1.9 20.5 3 20.5H21C22.1 20.5 23 19.6 23 18.5V5.5C23 4.4 22.1 3.5 21 3.5ZM21 18.5H12V5.5H21V18.5Z',
      key: '1b5l9t',
    },
  ],
]);

export default ChromeReaderMode;
